import { HeadingCompact01 } from 'module/ui/components/styles';
import { Editor, NodeViewContent } from '@tiptap/react';
import {
  CustomGroupSectionNode,
  CustomSectionState,
} from 'api/custom-section/types';
import { FC, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CustomGroupSectionPromptInput } from './input';
import { CustomGroupSectionPromptPreview } from './preview';
import { CustomGroupSectionComponentProps } from '../../types';
import {
  findCustomGroupSectionIndex,
  getNumberOfCustomGroupSections,
} from '../../utils';

const Header = styled.div`
  background-color: var(--blue-80);
  ${HeadingCompact01};
  padding: var(--spacing-03) var(--spacing-05);
  color: var(--text-on-color);
  border-top-left-radius: var(--border-radius-small);
  border-top-right-radius: var(--border-radius-small);
`;
const ContentWrapper = styled.div``;
const calculateIndexAndTotalSections = (
  editor: Editor,
  node: CustomGroupSectionNode,
) => {
  const json = editor.getJSON();

  return {
    totalNumberOfCustomGroupSections: getNumberOfCustomGroupSections(json),
    customGroupSectionIndex: findCustomGroupSectionIndex(json, node),
  };
};

export const CustomGroupSectionPrompt: FC<CustomGroupSectionComponentProps> = (
  props,
) => {
  const [indexAndTotalSections, setIndexAndTotalSections] = useState<{
    totalNumberOfCustomGroupSections: number;
    customGroupSectionIndex: number;
  }>(calculateIndexAndTotalSections(props.editor, props.node));

  useEffect(() => {
    const updateIndexAndTotalSections = () => {
      setIndexAndTotalSections(
        calculateIndexAndTotalSections(props.editor, props.node),
      );
    };

    props.editor.on('update', updateIndexAndTotalSections);

    return () => {
      props.editor.off('update', updateIndexAndTotalSections);
    };
  }, [props.editor, props.node]);

  const [isEditing, setIsEditing] = useState(
    props.node.attrs.state === CustomSectionState.Open,
  );

  return (
    <div>
      <ContentWrapper>
        <Header>
          <FormattedMessage
            id="rich_text_editor.sections.custom_group_section.header"
            values={{
              current: indexAndTotalSections.customGroupSectionIndex + 1,
              total: indexAndTotalSections.totalNumberOfCustomGroupSections,
            }}
          />
        </Header>
        {isEditing ? (
          <CustomGroupSectionPromptInput
            {...props}
            onEditDone={() => {
              setIsEditing(false);
            }}
          />
        ) : (
          <CustomGroupSectionPromptPreview
            {...props}
            onWrapperClick={() => {
              setIsEditing(true);
            }}
          />
        )}
      </ContentWrapper>
      <NodeViewContent />
    </div>
  );
};
